import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.88 3.45333C9.62 3.19333 9.2 3.19333 8.94 3.45333L5.12 7.27333C4.86 7.53333 4.86 7.95333 5.12 8.21333L8.94 12.0333C9.2 12.2933 9.62 12.2933 9.88 12.0333C10.14 11.7733 10.14 11.3533 9.88 11.0933L6.54667 7.74667L9.88 4.4C10.1333 4.14667 10.1333 3.71333 9.88 3.45333Z",
		fill: "currentColor"
	})
});
export default SvgChevronLeft;
